import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_10: FaireProductEntity = {
  token: "nyc-soap-10",
  type: "product",
  name: "Chelsea Peppermint Foot Soak",
  brandName: "Chelsea Spa Essentials",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7b0108d085017ccb44ed5e95b0ff5258f1b8c1bbe54cd044192442aea2222fff.webp",
  priceDollars: 17,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/7b0108d085017ccb44ed5e95b0ff5258f1b8c1bbe54cd044192442aea2222fff.webp",
  weight: 0.9,
  dimensions: {
    width: 4,
    height: 5,
    depth: 2,
  },
  description: "Refreshing peppermint foot soak",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "spa", "wellness"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
